import React from 'react';
import { Search } from 'lucide-react';

export default function SearchBar({ value, onSearch, placeholder = 'Search...' }) {
  return (
    <div className="search-bar">
      <Search size={20} />
      <input
        type="text"
        value={value}
        onChange={(e) => onSearch(e.target.value)}
        placeholder={placeholder}
        className="search-input"
      />
    </div>
  );
}
